// Angular or Core
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
// Model
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { PwaUsage } from '@core/models/pwa-usage.model';
// Third Party
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class PwaUsageDataService extends DefaultDataService<PwaUsage> {

  pagination: Pagination;

  /**
   * Distinct members in the current filter. Kept separate from pagination.total because with
   * "include anonymous" on, the paginator counts devices, not members.
   */
  memberTotal = 0;

  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
  ) {
    super('PwaUsage', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<PwaUsage[]> {
    return this.http.get<ApiResponse>(`/pwausage${pageParam}`).pipe(
      tap(res => {
        this.paginationInit(res);
        this.memberTotal = res?.data?.member_total ?? 0;
      }),
      map(res => res.data.rows),
    );
  }

  /**
   * Details for one member. Returns the whole data envelope (member + devices + paginated
   * activities) rather than mapping to rows, because the dialog needs all three.
   */
  getMemberDetail(memberId: number, pageParam: string = ''): Observable<any> {
    return this.http.get<ApiResponse>(`/pwausage/${memberId}${pageParam}`).pipe(
      map(res => res.data),
    );
  }

  private paginationInit(res: any) {
    if (res) {
      return this.pagination = res.data.paginations;
    }
  }

}
